import { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { authSelector } from '../../features/auth/slice';

export default function LikeButton({ targetType, targetId }) {
  const { me } = useSelector(authSelector.selectAuthState);
  const [liked, setLiked] = useState(false);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get('/api/content-like', { params: { targetType, targetId } })
      .then((res) => { setLiked(res.data.liked); setCount(res.data.count); })
      .catch(() => {});
  }, [targetType, targetId]);

  const toggle = async () => {
    if (!me) return;
    if (loading) return;
    setLoading(true);
    // optimistic update
    setLiked((v) => !v);
    setCount((c) => liked ? c - 1 : c + 1);
    try {
      const res = await axios.post('/api/content-like', { targetType, targetId }, { withCredentials: true });
      setLiked(res.data.liked);
      setCount(res.data.count);
    } catch {
      // rollback
      setLiked((v) => !v);
      setCount((c) => liked ? c + 1 : c - 1);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={toggle}
      title={me ? (liked ? '좋아요 취소' : '좋아요') : '로그인 후 이용 가능'}
      className={`flex items-center gap-1.5 transition-colors ${
        liked
          ? 'text-rose-400 hover:text-rose-300'
          : 'text-slate-400 hover:text-rose-400'
      } ${!me ? 'cursor-default' : ''}`}>
      <Heart size={17} fill={liked ? 'currentColor' : 'none'} />
      {count > 0 && <span className="text-xs font-medium">{count.toLocaleString()}</span>}
    </button>
  );
}
